import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Thu Aug 09 2018
 * @author BPo
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

import * as React from 'react';
import { observer, inject } from 'mobx-react';
import Loader from '../../info/Loader';
import { StoreName } from '../../../shared/stores/StoreName';

var LoginControl =
/*#__PURE__*/
function (_React$Component) {
  _inherits(LoginControl, _React$Component);

  function LoginControl() {
    _classCallCheck(this, LoginControl);

    return _possibleConstructorReturn(this, _getPrototypeOf(LoginControl).apply(this, arguments));
  }

  _createClass(LoginControl, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      /** Authenticate user when store is created */
      this.props.keycloakStore.initialize();
    }
    /**
     *  Check if user is authenticated.
     */

  }, {
    key: "render",
    value: function render() {
      if (!this.props.keycloakStore.isAuthenticated) {
        return React.createElement(Loader, null);
      }

      return this.props.children;
    }
  }]);

  return LoginControl;
}(React.Component);

LoginControl = __decorate([inject(function (allStores) {
  return {
    keycloakStore: allStores[StoreName.Keycloak]
  };
}), observer], LoginControl);
export default LoginControl;